import React, {useEffect, useMemo, useState} from "react";
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import {AgGridReact} from "ag-grid-react";
import {useQuery} from "@tanstack/react-query";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../utils/ag-grid-columns-utils.js";
import GarrisonService from "../../../../../services/dispatch/garrison-service.js";

const ScheduleActivitiesGrid = ({activities = []}) => {
    const columnDefs = useMemo(() => [
        {field: "startText", headerName: "Horário", width: 120},
        {field: "duration", headerName: "Duração", width: 110},
        {field: "reason", headerName: "Natureza", flex: 1},
        {field: "priority", headerName: "Prioridade", width: 110},
        {field: "placeDescr", headerName: "Endereço", flex: 1, wrapText: true, autoHeight: true},
        {field: "description", headerName: "Descrição", flex: 1, wrapText: true, autoHeight: true},
    ], []);

    return (
        <AgGridReact
            domLayout="autoHeight"
            rowData={activities}
            columnDefs={columnDefs}
            defaultColDef={{...DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL, sortable: false}}
            animateRows={false}
            suppressCellFocus={true}
            gridOptions={{localeText: aggridUtils.localization()}}
            theme={aggridUtils.generalTheme({noOddRow: true})}
            overlayNoRowsTemplate="Nenhuma atividade."
        />
    );
};

const GarrisonScheduleModal = ({open, setOpen, garrisonId, groups, onConfirm}) => {
    const [checked, setChecked] = useState({});

    const {data: schedules = [], isFetching} = useQuery({
        queryFn: () => GarrisonService.getListSchedules(garrisonId, groups),
        queryKey: ["garrison-schedule-list", garrisonId, groups],
        enabled: open,
    });

    useEffect(() => {
        if (!open) return;
        const initial = {};
        (schedules ?? []).forEach(schedule => { initial[schedule.id] = !!schedule.autoApplyByGroup; });
        setChecked(initial);
    }, [schedules, open]);

    const toggle = (id, value) => setChecked(prev => ({...prev, [id]: value}));

    const confirm = () => {
        const selected = (schedules ?? []).filter(schedule => checked[schedule.id]);
        onConfirm(selected);
        setOpen(false);
    };

    return (
        <Modal open={open} setOpen={setOpen} title="Atividades programadas" className="w-10/12">
            <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto">
                <div className="max-h-[calc(100vh-260px)] overflow-y-auto space-y-3">
                    {!isFetching && !schedules.length &&
                        <h4 className="text-center">Não há atividades a serem listadas para essa guarnição</h4>
                    }
                    {(schedules ?? []).map(schedule => (
                        <div className="rounded-lg border border-[#D2D3D5] overflow-hidden" key={schedule.id}>
                            <div className="flex items-center gap-2 px-3 py-2 border-b border-[#D2D3D5] bg-[#efefef]">
                                <InputCheckbox
                                    id={`add-schedule-${schedule.id}`}
                                    label={schedule.name}
                                    classNameLabel="font-semibold"
                                    checked={!!checked[schedule.id]}
                                    onChange={({target}) => toggle(schedule.id, target.checked)}
                                />
                            </div>

                            <div className={"p-3"}>
                                <ScheduleActivitiesGrid activities={schedule.activities}/>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={confirm}>Adicionar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GarrisonScheduleModal;
